import styled from "styled-components";

import { palette, pxToRem } from "@otta/design-tokens";

export const Divider = styled.hr`
  border-width: ${pxToRem(1)} 0 0 0;
  border-top: ${pxToRem(1)} solid ${palette.grayscale.shade200};
`;
